module.exports = __webpack_public_path__ + "img/user-x.80ef950f.svg";